import Icon from 'components/icon/Icon';
import { LifeStyleSection } from 'services/risk-checker/type';

export default function LifestyleRecommendations({
  data,
}: {
  data: LifeStyleSection | undefined;
}) {
  return (
    <div className='bg-[#F1F5F9] rounded-lg p-4 space-y-3'>
      <div className='flex items-center gap-3'>
        <div className='grid bg-white rounded-md size-8 place-content-center'>
          <Icon icon='light-bulb' size={20} color='#1A68D8' />
        </div>
        <h2 className='text-lg md:text-xl font-semibold text-tertiary'>
          Lifestyle Recommendations
        </h2>
      </div>

      <div className='grid lg:grid-cols-3 gap-4'>
        {data?.list.map((item) => (
          <div className='p-4 space-y-1 bg-white rounded-xl'>
            <div className='flex items-center justify-between'>
              <h3 className='font-semibold text-primary'>{item.name}</h3>
              <img
                crossOrigin='anonymous'
                src={item.image_url}
                alt={item.name}
                className='size-5 md:size-6'
              />
            </div>
            <p className='text-sm md:text-base font-medium text-[#656D76]'>
              {item?.body}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
